// toastSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  show: false,
  message: "",
  messagebold: "",
  type: "success",
};

/**
 * Creates a Redux slice for managing toast notifications.
 * @param {object} options - The options for creating the slice.
 * @param {string} options.name - The name of the slice.
 * @param {object} options.initialState - The initial state of the slice.
 * @param {object} options.reducers - The reducers for the slice.
 * @param {function} options.reducers.showToast - The reducer function for showing a toast notification.
 * @param {function} options.reducers.hideToast - The reducer function for hiding a toast notification.
 * @returns A Redux slice object for managing toast notifications.
 */
const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    showToast: (state, action) => {
      state.show = true;
      state.message = action.payload.message;
      state.type = action.payload.type;
    },
    hideToast: (state) => {
      state.show = false;
      state.message = "";
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;
